import { render, staticRenderFns } from "./GroupInitialScreen.vue?vue&type=template&id=a0ee6122&scoped=true&"
import script from "./GroupInitialScreen.vue?vue&type=script&lang=ts&"
export * from "./GroupInitialScreen.vue?vue&type=script&lang=ts&"
import style0 from "./GroupInitialScreen.vue?vue&type=style&index=0&id=a0ee6122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ee6122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
